/**
 *
 * Asynchronously loads the component for SignUp
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
